<form [formGroup]="form" novalidate *ngIf="form">
  <div>
    <input id="person-search" class="person-search-input" type="text" formControlName="search" autocomplete="off"
      placeholder="{{'ChangePlayer.SearchPlayerPlaceholder' | translate}}">
    <span class="ic-player-search person-search-icon"></span>
  </div>
</form>
<ul *ngIf="showPlayerList" class="person-search-list person-search-list-dropdown" role="menu"
  aria-labelledby="person-search">
  <li *ngFor="let player of players" (click)="onSelectPerson(player)">
    <app-court-booking-player-info [showRemoveButton]="false" [person]="player"></app-court-booking-player-info>
  </li>
</ul>
